import React from "react"
import { useSelector } from "react-redux";
import copyIcon from '../../../assests/copy.png'
import warnIcon from '../../../assests/WarnIcon.png'
import closeIcon from '../../../assests/close.png'
import classes from './SuccessProjectPopup.module.css'
import BackdropPopup from "../BackdropPopup/BackdropPopup";
import { onKeyDown } from "../../../service";

const SuccessProjectPopup = ({ close, color, type, title, children, myHeight, myWidth, minHeight, direction, padding, setClickShowShareProjectPopup, setNewPost }) => {

    const translate = useSelector((state) => state.translate);

    function handleClose(e) {
        setClickShowShareProjectPopup && setClickShowShareProjectPopup()
        setNewPost && setNewPost(true)
        close(e)
    }

    return (
        <BackdropPopup myHeight={myHeight} myWidth={myWidth} minHeight={minHeight}>
            <div className={classes.SubmissionPopupContainer} style={{ direction: direction || translate.direction, padding: padding }}>
                <div className={classes.Header} style={{ backgroundColor: color, width: myWidth ? myWidth : '482px' }}>
                    <div className={classes.HeaderText}>
                        {type === "duplicate" && <img className={classes.icon} src={copyIcon} alt="copyIcon" />}
                        {type === "Warn" && <img className={classes.icon} src={warnIcon} alt="warnIcon" />}
                        <h4>{title}</h4>
                    </div>
                    <div className={classes.HeaderClose}>
                        <img className={classes.CloseBtn} src={closeIcon} onClick={e => handleClose(e)} alt='closeIcon' tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleClose(e))}/>
                    </div>
                </div>
                <div className={`${classes[direction || translate.direction]} ${classes.ChildrenContainer}`}>
                    <div className={classes.ChildrenWrapper} >
                        {children}
                    </div>
                </div>
            </div>
        </BackdropPopup >
    )
}
export default SuccessProjectPopup;